import type { ClientOptions, PairingToken } from '@forgesworn/joystick-mobile';

/** Each tab retains only its own session's reconnect capability. */
export function recoveryOptions(token: PairingToken): ClientOptions {
  const key = `joystick:resume:${JSON.stringify([token.ws, token.sessionId, token.version ?? 1])}`;
  let resumeToken: string | undefined;
  try { resumeToken = sessionStorage.getItem(key) ?? undefined; } catch { /* Private browsing can disable storage. */ }
  return {
    resumeToken,
    onResumeToken(value) {
      try {
        if (value) sessionStorage.setItem(key, value);
        else sessionStorage.removeItem(key);
      } catch { /* In-memory reconnect still works. */ }
    },
  };
}
